// extracted by mini-css-extract-plugin
export default {"field":"links_field__T-Ytq","link":"links_link__RQhf6","disabled":"links_disabled__CWL9z","small":"links_small__jkCKo","big":"links_big__WIR-w","spinner":"links_spinner__dGewb"};